





















































import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class DownloadSurvey extends Vue {
  fileName: string = "";
  hasError: boolean = false;
  errorMessage = "";

  $refs!: {
    fileNameInput: HTMLInputElement;
    form: HTMLFormElement;
    submitButton: HTMLButtonElement;
  };

  showFileNameModal() {
    this.fileName = "";
    this.hasError = false;
    this.errorMessage = "";
    this.$bvModal.show("file-name-modal");
  }

  focusFileNameInput() {
    this.$refs.fileNameInput.focus();
  }

  onOkClicked() {
    this.$refs.submitButton.click();
  }

  onSubmit(event: any) {
    event.preventDefault();
    if (this.fileName.length == 0) {
      this.hasError = true;
      this.errorMessage = "validation.fileName.required";
      return;
    }
    this.$emit("confirmToDownload", this.fileName);
    this.$bvModal.hide("file-name-modal");
  }

  onCancelClicked() {
    this.$bvModal.hide("file-name-modal");
  }
}
